import { getStorage, removeStorage, setStorage } from "utils/storage";
import { requestFreshToken } from ".";

const TOKEN_URL = '/wms/token';

export const TOKEN_APIS = {
	renewToken: (refreshToken: string) => TOKEN_URL + `/${refreshToken}/renew`,
};

export function renewToken(refreshToken: string) {
	return requestFreshToken.post(TOKEN_APIS.renewToken(refreshToken));
}

export const getNewToken: () => Promise<string> = () => {
	// const isSupplierPage = getStorage("SUPPLIER_ID");
	const isSupplierPage = window.location.pathname.includes('/s2');
	const refreshToken = isSupplierPage ? (getStorage('SUPPLIER_REFRESH_TOKEN') ?? '') : (getStorage('refreshToken') ?? '');

	return new Promise(async (res, rej) => {
		try {
			let { code, body } = await (await renewToken(refreshToken)).data;
			switch (code) {
				case 200:
					if (isSupplierPage) {
						setStorage('SUPPLIER_ACCESS_TOKEN', body.accessToken, 'locale');
						setStorage('SUPPLIER_REFRESH_TOKEN', body.refreshToken, 'locale');
					} else {
						setStorage('accessToken', body.accessToken, 'locale');
						setStorage('refreshToken', body.refreshToken, 'locale');
					}
					res(body.accessToken);
					break;
				// case 69504:
				// case 70315: //添加一个70315，去获取token
				// 如果不成功 就需要走重新登录
				default:
					// const { loginStatus } = (store.getState() as unknown) as { loginStatus?: boolean };
					// if (loginStatus) {
					// store.dispatch({
					// 	type: types.CHANGE_LOGIN_STATUS,
					// 	data: false,
					// });
					// 清掉缓存
					removeStorage('refreshToken');
					removeStorage('accessToken');
					// window.location.href = LOGIN_PAGE;
					// } else {
					// }
					rej(false);
					break;
			}
		} catch (e) {
			rej(false);
		}
	});
};